import {
  refillRequestDefaultStatuses,
  refillRequestDeliveryTypes,
} from '../../../../config/app.config';

export const REFILL_SCOPE_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'all', label: 'All' },
];

export const REFILL_SORT_OPTIONS = [
  { value: 'createdAt', label: 'Date', defaultOrder: -1 },
  { value: 'parentFullName', label: 'Parent', defaultOrder: 1 },
  { value: 'petName', label: 'Pet', defaultOrder: 1 },
  { value: 'medication', label: 'Medication', defaultOrder: 1 },
];

export const PROFILE_REFILL_SORT_OPTIONS = [
  { value: 'createdAt', label: 'Date', defaultOrder: -1 },
  { value: 'petName', label: 'Pet', defaultOrder: 1 },
  { value: 'medication', label: 'Medication', defaultOrder: 1 },
];

export function getProfileRefillSortOptions({ petId } = {}) {
  if (petId) {
    return PROFILE_REFILL_SORT_OPTIONS.filter(
      (option) => option.value !== 'petName',
    );
  }
  return PROFILE_REFILL_SORT_OPTIONS;
}

export const REFILL_DATE_SHORTCUTS = [
  { value: 'today', label: 'Today' },
  { value: 'last 7 days', label: '7d' },
  { value: 'last 30 days', label: '30d' },
];

export const REFILL_OPEN_STATUSES = [
  refillRequestDefaultStatuses.requested,
  refillRequestDefaultStatuses.inTheQueue,
];

export const REFILL_FILTER_SEARCH_THRESHOLD = 8;

const STATUS_ORDER = [
  refillRequestDefaultStatuses.requested,
  refillRequestDefaultStatuses.inTheQueue,
  refillRequestDefaultStatuses.readyForPickup,
  refillRequestDefaultStatuses.shipped,
];

export function getRefillFilterCategories({ statuses = [], doctors = [] }) {
  const statusChoices = [...statuses]
    .sort(
      (a, b) =>
        STATUS_ORDER.indexOf(a.label) - STATUS_ORDER.indexOf(b.label),
    )
    .map((status) => ({
      value: status.label,
      label: status.label,
    }));

  const doctorChoices = doctors.map((doctor) => ({
    value: doctor._id,
    label: doctor.name,
  }));
  doctorChoices.push({ value: 'NA', label: 'N/A' });

  const deliveryChoices = Object.entries(refillRequestDeliveryTypes).map(
    ([value, label]) => ({ value, label }),
  );

  return [
    {
      key: 'status',
      label: 'Refill Status',
      choices: statusChoices,
    },
    {
      key: 'deliveryType',
      label: 'Delivery',
      choices: deliveryChoices,
    },
    {
      key: 'doctorId',
      label: 'Doctor',
      choices: doctorChoices,
    },
  ];
}
